import { useContext } from 'react';
import shoppingCart from '../assets/icons/shoppingCart.svg';
import { CartContext } from '../context/cartContext';
import { useGuestCart } from '../context/guestCartContext';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';

function FloatingCart() {
  const { cart } = useContext(CartContext);
  const location = useLocation();

  const isGuestPage = location.pathname.includes('/guest');
  const { user } = useAuth();
  let cartCount = 0;

  if (!user) {
    const { cartCount: guestCartCount } = useGuestCart();
    cartCount = isGuestPage ? guestCartCount : 0;
  } else {
    cartCount = cart?.line_items?.length || 0;
  }

  const cartLink = isGuestPage ? '/guest/cart' : '/cart';

  return (
    <Link to={cartLink}>
      <div
        className={
          'fixed bottom-[13%] right-[5%] w-[60px] h-[60px] bg-primary-blue-500 rounded-full z-[9999]'
        }
      >
        <img
          src={shoppingCart || '/placeholder.svg'}
          alt="Cart Icon"
          className="my-[15px] mx-auto"
        />
        <div
          className="absolute top-[-10px] right-[-6px] w-[30px] h-[30px] bg-white rounded-full flex items-center 
        justify-center border border-primary-blue-500 text-primary-blue-500 text-xs font-semibold"
        >
          {cartCount}
        </div>
      </div>
    </Link>
  );
}
export default FloatingCart;
